// extracted by mini-css-extract-plugin
module.exports = {"product":"product-module--product--3CiYY","title":"product-module--title--1DQwd"};